{
    "dropdown_option__delete": "Delete",
    "dropdown_option_release": "Release in ERP System",
    "ORDER__delete_confirmation__title": "Delete order?",
    "ORDER__delete_confirmation__description": "The order is deleted from Plato and the ERP system. This action cannot be undone.",
    "QUOTE__delete_confirmation__title": "Delete quote?",
    "QUOTE__delete_confirmation__description": "The quote is deleted from Plato and the ERP system. This action cannot be undone.",
    "ORDER__delete_toast__success_title": "Order succesfully deleted",
    "ORDER__delete_toast__success_description": "Here you can <linkTag>create a new transaction</linkTag>",
    "QUOTE__delete_toast__success_title": "Quote succesfully deleted",
    "QUOTE__delete_toast__success_description": "Here you can <linkTag>create a new transaction</linkTag>",
    "ORDER__release_toast__success_title": "Order successfully released",
    "ORDER__release_toast__success_description": "Here you can <linkTag>create a new transaction</linkTag>",
    "QUOTE__release_toast__success_title": "Quote successfully released",
    "QUOTE__release_toast__success_description": "Here you can <linkTag>create a new transaction</linkTag>",
    "ORDER__release_confirmation__title": "Release order in ERP?",
    "ORDER__release_confirmation__description": "This action can not be undone. Select if you would like to send a confirmation via PDF in a standard email to the customer.",
    "QUOTE__release_confirmation__title": "Release quote in ERP?",
    "QUOTE__release_confirmation__description": "This action can not be undone. Select if you would like to send a confirmation via PDF in a standard email to the customer.",
    "send_pdf_by_email": "Send confirmation via email",
    "do_not_send_pdf_by_email": "Do not send an email"
}
